import { actionTypes } from './actions';

export const initialState = {
  voice: {},
  isOpenPopupVoiceCloningOptions: false,
  refetchVoicesList: false,
};

const voiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ADD_VOICE: {
      const { voice } = action;
      return { ...state, voice };
    }

    case actionTypes.CLEAR_VOICE:
      return initialState;

    case actionTypes.OPEN_POPUP_VOICE_CLONING_OPTIONS:
      return { ...state, isOpenPopupVoiceCloningOptions: true };

    case actionTypes.CLOSE_POPUP_VOICE_CLONING_OPTIONS:
      return { ...state, isOpenPopupVoiceCloningOptions: false };

    case actionTypes.REFRESH_VOICES_LIST:
      return { ...state, refetchVoicesList: action.value };

    default:
      return state;
  }
};

export default voiceReducer;
